import { RootState } from '../store';
import { CustomerJob, JobResponse } from './types';
import { useAppSelector } from '../../app/useAppSelector';

export const useSelectedJob = (): JobResponse => {
    return useAppSelector((state: RootState) => state.jobsManagement.selectedJob);
  };

export const useSelectedClientsJob = ():  CustomerJob[] => {
    return useAppSelector((state: RootState) => state.jobsManagement.clientsJob);
  };